<template>
  <v-menu
      v-model="open"
      :close-on-content-click="false"
      :close-on-back="false"
      location="bottom"
      transition="slide-y-transition"
      class="text-left"
  >
    <template v-slot:activator="{ props, on }">
      <v-btn icon small class="mt-1" v-bind="props" v-on="on">
        <v-icon color="white" size="30">notifications</v-icon>
      </v-btn>
      <v-row
          v-show="notifications && notifications.length > 0"
          no-gutters
          style="position: relative; background: var(--additional-red); font-size: 13px; height: 22px; top: 0; left: 32px; z-index: 3; padding: 2px 0; margin-left: -22px;"
          v-bind="props"
          v-on="on"
          class="px-1 rounded-xl font-weight-bold"
      >{{ notifications ? notifications.length : 0 }}</v-row>
    </template>
    <v-row no-gutters @click="open = false" style="box-shadow: none!important;">
      <v-sheet style="box-shadow: 0 6px 20px 0 rgba(38, 54, 73, 0.32);
       background: rgba(0, 0, 0, 0); margin-top: 12px;border-radius: 15px;

">
        <v-list class="top_menu__button__list--title elevation-0 border-bottom" style="border-top-right-radius: 15px;border-top-left-radius: 15px;">
          <v-list-item variant="text" :lines="'one'" class="top_menu__button__list-item__prepend">
            <v-list-item-title class="top_menu__button__list-title text-left text-h7 font-weight-bold">
              Список уведомлений
            </v-list-item-title>
            <v-btn @click.stop="readAllNotifications()" icon class="mr-3">
              <v-icon color="var(--additional-red)">delete_forever</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
        <v-list
            style=" max-height: 400px; max-width: 500px; overflow-y: scroll; overflow-x: hidden; padding: 0; word-break: break-word;"
            v-if="notifications && notifications.length > 0">
          <v-list-item v-for="(notification, i) in notifications" :key="`notification_${i}`"
                       @click.stop="openLink(notification)" :class="i ? 'border-top' : ''">
            <v-icon color="var(--blue-shades-dark)" size="28">{{ notification?.visual_data?.icon }}</v-icon>
            <v-row class="wrap py-2 text-left px-3" no-gutters>
              <v-col cols="12" class="px-0 mx-0 top_menu__button__list-title text-subtitle-1 font-weight-bold"
                     style="font-size: 14px!important;">
                {{ notification?.system }} от {{ displayDate(notification?.generated, true) }}
              </v-col>
              <v-col cols="12" class="px-0 mx-0 top_menu__button__list-title text-subtitle-1"
                     style="word-break: break-word; line-height: 1rem;font-size: 14px!important;">
                <span style="color: black; opacity: 0.6;" v-html="notification?.text"/>
              </v-col>
            </v-row>
            <v-btn icon class="mt-1" @click.stop="readSingleNotification(notification)">
              <v-icon color="lightgray" size="20">close</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
        <v-list style="word-break: break-word;border-bottom-right-radius: 15px;border-bottom-left-radius: 15px;" class="text-center py-3 grey--text" v-else>
          Новых уведомлений нет
        </v-list>
      </v-sheet>
    </v-row>
  </v-menu>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {checkIsDevelopmentServer, displayDate} from "@/helper";


export default {
  name: "EventAlerts",
  data: () => {
    return {
      open: false,
      snackbar: true,
    }
  },
  computed: {
    ...mapGetters({
      notifications: "eventchain/getMessages"
    }),
  },
  watch: {
    notifications: {
      handler: function (value, oldValue) {
        this.show_numbers = false
        this.$nextTick(() => {
          this.show_numbers = true
        })
        if (value.length > 0) {
          if (value.length >= oldValue.length) {
            this.snackbar = true
          }
        }
      }
    },
    deep: true
  },
  methods: {
    displayDate: displayDate,
    checkIsDevelopmentServer: checkIsDevelopmentServer,
    ...mapActions({
      deleteMessages: "eventchain/deleteMessages",
      deleteAllMessages: "eventchain/deleteAllMessages"
    }),
    readSingleNotification(val) {
      this.deleteMessages({val: val})
    },
    readAllNotifications() {
      this.deleteAllMessages({})
    },
    openLink(data) {
      if (data.kind_data.target) {
        if (!data.kind_data.method) {
          const url = new URL(data.kind_data.target);
          for (const key in data.kind_data.gets) {
            url.searchParams.set(key, data.kind_data.gets[key]);
          }
          window.open(url, "_blank")
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.top_menu__button .v-btn.v-btn--density-default {
  margin: 0 12px;
  border-radius: 2000px;

  &:hover {
    background: var(--blue-shades-hover);
  }
}

.top_menu__button__list--title {
  padding: 0;
  border-radius: 15px 15px 0 0;
  background: var(--background-white);
}

.top_menu__button__list {
  padding: 0;
  border-radius: 0 0 15px 15px;
  background: var(--background-white);
}

.top_menu__button__list-item {
  border-bottom: 1px solid var(--blue-shades-focus);

  &:hover {
    background: var(--blue-shades-focus);
  }
}

.top_menu__button__list-item__prepend {
  border-bottom: 1px solid var(--blue-shades-focus);
}

.top_menu__button__list-title {
  padding-left: 24px;
  padding-right: 24px;
  color: var(--corporate-main);
}

.snackbar__subtitle {
  color: black;
  opacity: 0.9;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.border-bottom {
  border-bottom: 1px solid lightgray;
}

.border-top {
  border-top: 1px solid lightgray;
}
</style>
